<template>
    <div>
        <v-container fluid pt-0 grid-list-xl>
            <section-tooltip title="Partner > Events > Guests"></section-tooltip>
            <app-card customClasses="mb-30 inherit-overflow">
                <div>
                    <h3>{{ selectedEvent.eventName }} | {{ selectedPartner.name }}</h3>
                </div>
                <div class="partner-contact-container">
                    <v-form v-model="valid">
                        <h5>Default contact person</h5>
                        <v-layout row wrap>
                            <v-flex md2>
                                <v-text-field v-model="defaultContactDetails.name" :rules="nameRules" label="Name"
                                    required>
                                </v-text-field>
                            </v-flex>
                            <v-flex md2>
                                <v-text-field v-model="defaultContactDetails.mobile" label="Mobile"
                                    required>
                                </v-text-field>
                            </v-flex>
                            <v-flex md4>
                                <v-text-field v-model="defaultContactDetails.email" :rules="emailRules" label="E-mail"
                                    required>
                                </v-text-field>
                            </v-flex>
                            <v-flex md1>
                                <v-btn @click="saveContact()" color="primary">
                                    <v-icon style="margin-right:10px">
                                        save
                                    </v-icon>
                                    Save
                                </v-btn>
                            </v-flex>
                        </v-layout>

                    </v-form>
                </div>
                <v-tooltip bottom>
                    <v-btn slot="activator" fab dark color="blue" small absolute top right @click="excelExport">
                        <v-icon dark>grid_on</v-icon>
                    </v-btn>
                    <span>Export Excel</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <v-btn slot="activator" :loading="isAllDownloading" style="margin-right:60px" fab dark color="blue"
                        small absolute top right @click="downloadAll">
                        <v-icon dark>download</v-icon>
                    </v-btn>
                    <span>Download all Documents</span>
                </v-tooltip>
                <v-data-table v-bind:headers="headers" :loading="loading" :items="eventGuests"
                    :pagination.sync="pagination" :total-items="totalGuests">
                    <template slot="items" slot-scope="props">
                        <td>{{ props.item.day_of_attendance }}</td>
                        <td>{{ props.item.first_name }}</td>
                        <td>{{ props.item.last_name }}</td>
                        <td>{{ props.item.job_description }}</td>
                        <td>{{ props.item.email }}</td>
                        <td>{{ props.item.country }}</td>
                        <td>
                            <v-btn style="margin-left:0px" v-if="props.item.document_path !== ''"
                                @click="downloadImage(props.item.document_path, props.item.last_name + '_' + props.item.first_name)">
                                <v-icon class="grey--text">
                                    download
                                </v-icon>
                                <span style="margin-left:10px">Download</span>
                            </v-btn>
                        </td>
                        <td>
                            <v-btn style="margin-left:0px" v-if="props.item.image_path !== ''"
                                @click="downloadImage(props.item.image_path, props.item.last_name + '_' + props.item.first_name)">
                                <v-icon class="grey--text">
                                    download
                                </v-icon>
                                <span style="margin-left:10px">Download</span>
                            </v-btn>
                        </td>
                        <td>
                            <v-btn style="margin-left:0px" >
                                <v-icon class="grey--text">
                                    delete
                                </v-icon>
                                <span style="margin-left:10px">Delete</span>
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
            </app-card>
        </v-container>
    </div>

</template>
<script>
import { mapGetters } from 'vuex'
import api from 'api-client'
const zip = require("jszip");

export default {
    computed: {
        ...mapGetters([
            'selectedEvent',
            'user'
        ]),
        selectedPartner() {
            return this.selectedEvent.partners.find((p) => p.id === this.partnerId);
        },
        defaultContactDetails() {
            const defaultContactDetails = this.selectedEvent.partners.find((p) => p.id === this.partnerId).contactDetails;

            if (!defaultContactDetails) {
                return {
                    name: '',
                    mobile: '',
                    email: ''
                }
            }
            return defaultContactDetails;
        }
    },
    data() {
        return {
            headers: [
                {
                    text: 'Day of Attendance',
                    value: "day_of_attendance",
                    align: 'left',
                },
                {
                    text: 'Name',
                    value: "first_name",
                    align: 'left',
                },
                {
                    text: 'Surname',
                    value: "last_name",
                    align: 'left',
                },
                {
                    text: 'Job description',
                    value: "job_description",
                    align: 'left',
                },
                {
                    text: 'Email',
                    value: "email",
                    align: 'left',
                },
                {
                    text: 'Country of residence',
                    value: "country",
                    align: 'left',
                },
                {
                    text: 'Documents',
                    align: 'left',
                },
                {
                    text: 'Image',
                    align: 'left',
                },
                {
                    text: 'Delete',
                    align: 'left',
                }
            ],
            totalGuests: 0,
            eventId: 0,
            partnerId: 0,
            valid: false,
            nameRules: [
                v => !!v || 'Name is required'
            ],
            mobileRules: [
                v => !!v || 'Field is required',
                v => /^(\+\d{1,3}[- ]?)?\d{10}$/.test(v) || 'Mobile must be valid'
            ],
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid',
            ],
            isSingleDownloading: '',
            isAllDownloading: false,
            pagination: {
            },
            eventGuests: []
        }
    },
    watch: {
        pagination: {
            handler() {
                this.getDataFromApi()
            },
            deep: true,
        },
    },
    methods: {
        saveContact() {
            const params = {
                entity: this.defaultContactDetails,
                partnerId: this.partnerId,
                eventId: this.selectedEvent.eventId,
                internalId: this.eventId
            }
            this.$store.dispatch('updateDefaultPartnerContact', params);
        },
        async excelExport() {
            api.downloadExcel({
                partnerInfo: {
                    name: this.selectedPartner.name,
                    partnerId: this.partnerId,
                    contact: this.defaultContactDetails
                },
                eventInfo: {
                    name: this.selectedEvent.eventName,
                    eventId: this.selectedEvent.eventId
                },
                companyId: this.user.company.id,
                contactDetails: this.user.partnerDetailsContact
            }).then((response) => {
                const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url;
                link.setAttribute('download', 'guest-list.xlsx')
                document.body.appendChild(link)
                link.click()
            })
                .catch((error) => console.log(error))

        },
        async downloadImage(url, name) {
            if (url !== '') {
                const image = await fetch(url)
                const imageBlob = await image.blob()
                const imageURL = URL.createObjectURL(imageBlob)

                const link = document.createElement('a')
                link.href = imageURL
                link.download = name + '.' + (url.substring(url.lastIndexOf('/') + 1)).split('.')[1]
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            }
        },
        async getBlob(url) {
            if (url !== '') {
                const image = await fetch(url)
                const imageBlob = await image.blob()
                return imageBlob;
            }
        },
        getDataFromApi() {
            this.loading = true
            this.eventGuestsApiCall().then((data) => {
                this.eventGuests = data.items
                this.totalGuests = data.total
                this.loading = false
            })
        },
        eventGuestsApiCall() {
            const { sortBy, descending } = this.pagination
            const params = {
                query: {
                    partner_id: this.partnerId,
                    event_id: this.selectedEvent.eventId,
                },
                take: this.pagination.rowsPerPage,
                skip: (this.pagination.page - 1) * this.pagination.rowsPerPage
            }
            if (this.pagination.rowsPerPage === -1) {
                delete params.take
                delete params.skip
            }
            return api.getEventGuests(params).then((result) => {
                let items = result.items;
                const total = result.total
                if (this.pagination.sortBy) {
                    items = items.sort((a, b) => {
                        const sortA = a[sortBy]
                        const sortB = b[sortBy]

                        if (descending) {
                            if (sortA < sortB) return 1
                            if (sortA > sortB) return -1
                            return 0
                        } else {
                            if (sortA < sortB) return -1
                            if (sortA > sortB) return 1
                            return 0
                        }
                    })
                }
                return {
                    items,
                    total,
                }
            })
        },
        async downloadAll() {
            this.isAllDownloading = true;
            const zipFile = new zip();


            for (let index = 0; index < this.eventGuests.length; index++) {
                const g = this.eventGuests[index];
                const userFolder = zipFile.folder((index + 1) + "_" + g.first_name + '_' + g.last_name)

                if (g.image_path) {
                    const imageBlob = this.getBlob(g.image_path)
                    userFolder.file(g.last_name + '_' + g.first_name + '.jpeg', imageBlob)
                }
                if (g.document_path) {
                    const documentBlob = this.getBlob(g.document_path)
                    userFolder.file(g.last_name + '_' + g.first_name + '.pdf', documentBlob)
                }

            }

            zipFile.generateAsync({ type: "blob" }).then((file) => {
                var fileName = new Date().toISOString() + "_corona-documents.zip";
                const url = window.URL.createObjectURL(file)
                const link = document.createElement('a')
                link.href = url;
                link.setAttribute('download', fileName)
                document.body.appendChild(link)
                link.click()
                this.isAllDownloading = false;
            })
        }
    },
    created() {
        if (this.$route.params.eventId && this.$route.params.partnerId) {
            this.eventId = this.$route.params.eventId;
            this.partnerId = +this.$route.params.partnerId;
            this.$store.dispatch('getGuestDetailsEvent', this.eventId);
        } else {
            this.$router.push({ name: 'guest-details.event-partner' });
        }
    }
}
</script>